const translations: Record<string, string> = {
  "ak_home_january": "January",
  "ak_home_february": "February",
  "ak_home_march": "March",
  "ak_home_april": "April",
  "ak_home_may": "May",
  "ak_home_june": "June",
  "ak_home_july": "July",
  "ak_home_august": "August",
  "ak_home_september": "September",
  "ak_home_october": "October",
  "ak_home_november": "November",
  "ak_home_december": "December",
  "ak_home_jan": "Jan",
  "ak_home_feb": "Feb",
  "ak_home_mar": "Mar",
  "ak_home_apr": "Apr",
  "ak_home_may_2": "May",
  "ak_home_jun": "Jun",
  "ak_home_jul": "Jul",
  "ak_home_aug": "Aug",
  "ak_home_sep": "Sep",
  "ak_home_oct": "Oct",
  "ak_home_nov": "Nov",
  "ak_home_dec": "Dec",
  "ak_home_mon": "Mon",
  "ak_home_tue": "Tue",
  "ak_home_wed": "Wed",
  "ak_home_thu": "Thu",
  "ak_home_fri": "Fri",
  "ak_home_sat": "Sat",
  "ak_home_sun": "Sun",
  "ak_home_previous_year": "Previous year",
  "ak_home_previous_month": "Previous month",
  "ak_home_next_year": "Next year",
  "ak_home_next_month": "Next month",
  "ak_home_today": "Today",
  "ak_home_sunny": "Sunny",
  "ak_home_mostly_clear": "Mostly clear",
  "ak_home_partly_cloudy": "Partly cloudy",
  "ak_home_overcast": "Overcast",
  "ak_home_fog": "Fog",
  "ak_home_drizzle": "Drizzle",
  "ak_home_rain": "Rain",
  "ak_home_snow": "Snow",
  "ak_home_thunderstorm": "Thunderstorm",
  "ak_home_alarm": "Alarm",
  "ak_home_no_data": "No data",
  "ak_home_curtailed": "Curtailed",
  "ak_home_partial": "Partial",
  "ak_home_running": "Running",
  "ak_home_mw": "MW",
  "ak_home_mwh": "MWh",
  "ak_home_discharging": "discharging",
  "ak_home_charging": "charging",
  "ak_home_idle": "idle",
  "ak_home_no_data_2": "no data",
  "ak_home_bess": "BESS",
  "ak_home_capacity": "Capacity",
  "ak_home_generation_now": "Generation now",
  "ak_home_generated_today": "Generated today",
  "ak_home_inverters": "Inverters",
  "ak_home_colleague": "colleague",
  "ak_home_good_night": "Good night",
  "ak_home_good_morning": "Good morning",
  "ak_home_good_afternoon": "Good afternoon",
  "ak_home_good_evening": "Good evening",
  "ak_home_home": "Home",
  "ak_home_dashboard": "Dashboard",
  "ak_home_total_power": "Total power",
  "ak_home_generated_today_2": "Generated today",
  "ak_home_stations_active": "Stations active",
  "ak_home_avg_load": "Avg. load",
  "ak_home_loading_portfolio": "Loading portfolio…",
  "ak_home_failed_to_collect_hourly_trades_for_th": "Failed to collect hourly trades for the month - the source did not respond. Try again or select a day.",
  "ak_home_arithmetic_mean_by_hour_days_with_data": "arithmetic mean by hour · days with data: {{n}}",
  "ak_home_uah_mwh": "UAH/MWh",
  "ak_home_no_comparison": "no comparison",
  "ak_home_dam_prices": "DAM prices",
  "ak_home_per_day": "Per day",
  "ak_home_per_month": "Per month",
  "ak_home_previous_day": "Previous day",
  "ak_home_next_day": "Next day",
  "ak_home_loading": "Loading…",
  "ak_home_day_hr_8_23": "Day (hr 8–23)",
  "ak_home_night_hr_1_7_24": "Night (hr 1–7, 24)",
  "ak_home_peak_hr_18_23": "Peak (hr 18–23)",
  "ak_home_semi_peak_hr_8_17": "Semi-peak (hr 8–17)",
  "ak_home_calculating": "calculating…",
  "ak_home_recalculating": "recalculating…",
  "ak_home_clouds": "Clouds",
  "ak_home_cloud_tops": "Cloud tops",
  "ak_home_wind": "Wind",
  "ak_home_gusts": "Gusts",
  "ak_home_temperature": "Temperature",
  "ak_home_precipitation": "Precipitation",
  "ak_home_total_precipitation": "Total precipitation",
  "ak_home_pressure": "Pressure",
  "ak_home_the_weather_map_failed_to_load": "The weather map failed to load",
  "ak_home_the_windy_service_did_not_respond_the": "The Windy service did not respond. The rest of the page data does not depend on it.",
  "ak_home_try_again": "Try again",
  "ak_home_january_2": "January",
  "ak_home_february_2": "February",
  "ak_home_march_2": "March",
  "ak_home_april_2": "April",
  "ak_home_may_3": "May",
  "ak_home_june_2": "June",
  "ak_home_july_2": "July",
  "ak_home_august_2": "August",
  "ak_home_september_2": "September",
  "ak_home_october_2": "October",
  "ak_home_november_2": "November",
  "ak_home_december_2": "December",
  "ak_home_minimum_over_the_period_mn_buffer_ok": "minimum over the period {{d}}: {{v}} mn · buffer OK",
  "ak_home_uah_k": "UAH k",
  "ak_home_uah": "UAH",
  "ak_home_uah_mn": "UAH mn",
  "ak_home_loan_principal_250_000_interest": "Loan: principal €250,000 + interest",
  "ak_home_payment_for_21_30_09": "Payment for 21–30.09",
  "ak_home_payroll_social_tax_security": "Payroll, social tax, security",
  "ak_home_land_lease": "Land lease",
  "ak_home_payment_for_1_10_10": "Payment for 1–10.10",
  "ak_home_o_m_management_ppko": "O&M + management/PPKO",
  "ak_home_cash_next_14_days": "Cash · next 14 days",
  "ak_home_uah_mn_in_the_account": "UAH mn in the account",
  "ak_home_date": "Date",
  "ak_home_event": "Event",
  "ak_home_amount": "Amount",
  "ak_home_mn": "mn",
  "ak_home_demo_data_from_the_reference_the_cabin": "Demo data from the reference: the cabinet does not receive account movements yet.",
  "ak_home_chart_month": "Chart month",
  "ak_home_return_the_chart_to_the_month_of_the_s": "Return the chart to the month of the selected date",
  "ak_home_to_selected_date": "to selected date",
  "ak_home_no_data_for_this_month": "No data for this month",
  "ak_home_generation_actual": "Generation actual",
  "ak_home_generation_forecast": "Generation forecast",
  "ak_home_bess_charge": "BESS charge",
  "ak_home_bess_discharge": "BESS discharge",
  "ak_home_trading_schedule": "Trading schedule",
  "ak_home_delivered_to_grid": "Delivered to grid",
  "ak_home_avg_realization_price": "Avg. realization price",
  "ak_home_dam_price_day_8_23": "DAM price, day 8–23",
  "ak_home_income_calculated": "Income (calculated)",
  "ak_home_income_planned": "Income (planned)",
  "ak_home_income_dynamics": "Income dynamics",
  "ak_home_uah_k_day": "UAH k / day",
  "ak_home_uah_mn_cumulative": "UAH mn, cumulative",
  "ak_home_day_plan": "day plan",
  "ak_home_day_actual": "day actual",
  "ak_home_cumulative_plan": "cumulative plan",
  "ak_home_cumulative_actual": "cumulative actual",
};

export default translations;
